module.exports = __webpack_public_path__ + "img/izertis-map.90124889.png";